module.exports = __webpack_public_path__ + "img/cassiore.12d1cba7.jpeg";